// extracted by mini-css-extract-plugin
export default {"clock":"Clock_clock__oai0k"};